<template>
  <div>
    <header-section></header-section>
    <v-content>
      <v-container fluid>
        <v-layout row wrap>
          <!--<breadcrumbs v-if="$root.breadcrumbs.length"></breadcrumbs>-->
          <v-slide-y-transition mode="out-in">
            <router-view></router-view>
          </v-slide-y-transition>
        </v-layout>
      </v-container>
    </v-content>
    <footer-section></footer-section>
  </div>
</template>

<script>

  import Breadcrumbs from '../partials/Breadcrumbs'
  import Header from '../partials/Header'
  import Footer from '../partials/Footer'

  export default {
    name: 'Home',
    data () {
      return {
        
      }
    },
    components: {
      'breadcrumbs': Breadcrumbs,
      'header-section': Header,
      'footer-section': Footer
    }
  }
</script>
<style>
.v-list__tile--active {
    color: #006cb7 !important
  }
.input-group label {
  text-overflow: unset;
}
.comment-width {
  min-width:260px;
}
table.v-table thead td:not(:nth-child(1)), table.v-table tbody td:not(:nth-child(1)), table.v-table thead th:not(:nth-child(1)), table.v-table tbody th:not(:nth-child(1)), table.v-table thead td:first-child, table.v-table tbody td:first-child, table.v-table thead th:first-child, table.v-table tbody th:first-child {
  padding: 0 12px
}
table.v-table th {
  text-align: center !important
}
table.v-table .v-menu .v-menu__activator a, table.v-table td div  {
  width: 100%;
  text-align: center
}
table.v-table td {
  text-align: center
}
.full-pallet {
  background-color: skyblue
}
.marker-text div {
  color:#f4f4f4 !important
}
.loader-wrapper {
  left: calc(50% - 70px);
  top: 30%;
  right: 0 !important;
  bottom:0 !important;
}
.inline-block {
  display: inline-block !important;
}
</style>